import { faCheck, faTimes } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { Button } from '@domain-group/suit-theme'

import { useSetState } from '@domain-group/react-hooks'

import type { InvoiceModel } from '@models/types'
import useFlipperKey from '@hooks/useFlipperKey'
import useInvoice from '@hooks/useInvoice'

import useCurrentUser from '@hooks/useCurrentUser'

const defaultState = {
  loading: false,
  updating: false,
}

interface InvoiceItemTableFooterProps {
  invoice: InvoiceModel,
}

const InvoiceItemTableFooter = (props: InvoiceItemTableFooterProps) => {
  const { invoice: initInvoice } = props

  const [state, setState] = useSetState(defaultState)
  const { loading, updating } = state

  const invoicePayload = useInvoice(initInvoice)
  const {
    callbacks: {
      approveInvoice: approveFn,
      handleCallbackActionWithConfirmation,
      voidInvoice: voidFn,
    },
    invoice,
  } = invoicePayload

  const { approved } = invoice
  const isVoid: boolean = invoice.void

  const { isProviderUser } = useCurrentUser()
  const canViewActionButtons = !!isProviderUser

  const shouldShowApproveButton = canViewActionButtons && !approved && !isVoid

  const approveInvoicePayload = {
    callbacks: {
      actionFn: approveFn,
      afterAction: () => setState({ updating: false }),
      afterError: () => setState({ updating: false }),
      beforeAction: () => setState({ updating: true }),
    },
    strings: {
      actionString: 'approve',
    },
  }

  const voidInvoicePayload = {
    callbacks: {
      actionFn: voidFn,
      afterAction: () => setState({ loading: false }),
      afterError: () => setState({ loading: false }),
      beforeAction: () => setState({ loading: true }),
    },
    strings: {
      actionString: 'void',
    },
  }

  return (
    <>
      {canViewActionButtons && (
        <Button
          buttonStyle="secondaryUtility"
          disabled={approved || isVoid}
          icon={<FontAwesomeIcon icon={faTimes} />}
          loading={loading}
          onClick={() => {
            // @ts-expect-error TS2345
            handleCallbackActionWithConfirmation(voidInvoicePayload)
          }}
          size="medium"
          // @ts-expect-error TS2322
          width={['100%', 'auto']}
        >
          {isVoid ? 'Voided' : 'Void'}
        </Button>
      )}

      {shouldShowApproveButton && (
        <Button
          buttonStyle="primaryEdit"
          disabled={approved || isVoid}
          icon={<FontAwesomeIcon icon={faCheck} />}
          loading={updating}
          // @ts-expect-error TS2322
          marginLeft="medium"
          onClick={() => {
            // @ts-expect-error TS2345
            handleCallbackActionWithConfirmation(approveInvoicePayload)
          }}
          size="medium"
          width={['100%', 'auto']}
        >
          {approved ? 'Approved' : 'Approve'}
        </Button>
      )}

    </>

  )
}

export default InvoiceItemTableFooter
